/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Flex, Icon, Image, Text, View } from "@aws-amplify/ui-react";
export default function ProfileDetailsDesign(props) {
  const { person, overrides, ...rest } = props;
  return (
    <View
      width="402px"
      height="802px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      position="relative"
      border="1px SOLID rgba(179,179,179,1)"
      padding="0px 0px 0px 0px"
      backgroundColor="rgba(255,255,255,1)"
      {...rest}
      {...getOverrideProps(overrides, "ProfileDetailsDesign")}
    >
      <Flex
        gap="5px"
        direction="column"
        width="400px"
        height="unset"
        justifyContent="flex-start"
        alignItems="flex-start"
        position="absolute"
        top="175px"
        left="0px"
        padding="15px 15px 15px 15px"
        backgroundColor="rgba(255,255,255,1)"
        {...getOverrideProps(overrides, "ProfileDesignBody")}
      >
        <Text
          fontFamily="BIZ UDPGothic"
          fontSize="14px"
          fontWeight="700"
          color="rgba(0,0,205,1)"
          lineHeight="14px"
          textAlign="left"
          display="block"
          direction="column"
          justifyContent="unset"
          width="unset"
          height="unset"
          gap="unset"
          alignItems="unset"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          whiteSpace="pre-wrap"
          children="仕事内容 / 関心のあるテーマ"
          {...getOverrideProps(overrides, "title")}
        ></Text>
        <View
          width="unset"
          height="568px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          shrink="0"
          alignSelf="stretch"
          position="relative"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "container")}
        >
          <Text
            fontFamily="BIZ UDPGothic"
            fontSize="14px"
            fontWeight="400"
            color="rgba(0,0,0,1)"
            lineHeight="14px"
            textAlign="left"
            display="block"
            direction="column"
            justifyContent="unset"
            width="370px"
            height="unset"
            gap="unset"
            alignItems="unset"
            position="absolute"
            top="0px"
            left="0px"
            padding="0px 0px 0px 0px"
            whiteSpace="pre-wrap"
            children="吾輩（わがはい）は猫である。名前はまだ無い。&#xA;どこで生れたかとんと見当（けんとう）がつかぬ。何でも薄暗いじめじめした所でニャーニャー泣いていた事だけは記憶している。吾輩はここで始めて人間というものを見た。しかもあとで聞くとそれは書生という人間中で一番獰悪（どうあく）な種族であったそうだ。この書生というのは時々我々を捕（つかま）えて煮（に）て食うという話である。しかしその当時は何という考もなかったから別段恐しいとも思わなかった。ただ彼の掌（てのひら）に載せられてスーと持ち上げられた時何だかフワフワした感じがあったばかりである。掌の上で少し落ちついて書生の顔を見たのがいわゆる人間というものの見始（みはじめ）であろう。この時妙なものだと思った感じが今でも残っている。第一毛をもって装飾されべきはずの顔がつるつるしてまるで薬缶（やかん）だ。その後（ご）猫にもだいぶ逢（あ）ったがこんな片輪（かたわ）には一度も出会（でく）わした事がない。のみならず顔の真中があまりに突起している。そうしてその穴の中から時々ぷうぷうと煙（けむり）を吹く。どうも咽（む）せぽくて実に弱った。これが人間の飲む煙草（たばこ）というものである事はようやくこの頃知った。&#xA;この書生の掌の裏（うち）でしばらくはよい心持に坐っておったが、しばらくすると非常な速力で運転し始めた。書生が動くのか自分だけが動くのか分らないが無暗（むやみ）に眼が廻る。胸が悪くなる。到底（とうてい）助からないと思っていると、どさりと音がして眼から火が出た。それまでは記憶しているがあとは何の事やらいくら考え出そうとしても分らない。&#xA;ふと気が付いて見ると書生はいない。たくさんおった兄弟が一疋（ぴき）も見えぬ。肝心（かんじん）の母親さえ姿を隠してしまった。その上今（いま）までの所とは違って無暗（むやみ）に明るい。眼を明いていられぬくらいだ。はてな何でも容子（ようす）がおかしいと、のそのそ這（は）い出して見ると非常に痛い。吾輩は藁（わら）の上から急に笹原の中へ棄てられたのである。&#xA;ようやくの思いで笹原を這い出すと向うに大きな池がある。吾輩は池の前に坐ってどうしたらよかろうと考えて見た。別にこれという分別（ふんべつ）も出ない。しばらくして泣いたら書生がまた迎に来てくれるかと考え付いた。ニャー、ニャーと試みにやって見たが誰も来ない。そのうち池の上をさらさらと風が渡って日が暮れかかる。腹が非常に減って来た。泣きたくても声が出ない。仕方がない、何でもよいから食物（くいもの）のある所まであるこうと決心をしてそろりそろりと池を左（ひだ）りに廻り始めた。どうも非常に苦しい。そこを我慢して無理やりに這（は）って行くとようやくの事で何となく人間臭い所へ出た。ここへ這入（はい）ったら、どうにかなると思って竹垣の崩（くず）れた穴から、とある邸内にもぐり込んだ。縁は不思議なもので、もしこの竹垣が破れていなかったなら、吾輩はついに路傍（ろぼう）に餓死（がし）したかも知れんのである。一樹の蔭とはよく云（い）ったものだ。この垣根の穴は今日（こんにち）に至るまで吾輩が隣家（となり）の三毛を訪問する時の通路になっている。さて邸（やしき）へは忍び込んだもののこれから先どうして善（い）いか分らない。そのうちに暗くなる、腹は減る、寒さは寒し、雨が降って来るという始末でもう一刻の猶予（ゆうよ）が出来なくなった。仕方がないからとにかく明るくて暖かそうな方へ方へとあるいて行く。今から考えるとその時はすでに家の内に這入っておったのだ。ここで吾輩は彼（か）の書生以外の人間を再び見るべき機会に遭遇（そうぐう）したのである。第一に逢ったのがおさん（台所で働く下女の通称。おさんどん）である。これは前の書生より一層乱暴な方で吾輩を見るや否やいきなり頸筋（くびすじ）をつかんで表へ抛（ほう）り出した。いやこれは駄目だと思ったから眼をねぶって運を天に任せていた。しかしひもじいのと寒いのにはどうしても我慢が出来ん。吾輩は再びおさんの隙（すき）を見て台所へ這（は）い上（あが）った。すると間もなくまた投げ出された。吾輩は投げ出されては這い上り、這い上っては投げ出され、何でも同じ事を四五遍繰り返したのを記憶している。その時におさんと云う者はつくづくいやになった。この間おさんの三馬（さんま＝魚のサンマのこと）を偸（ぬす）んでこの返報をしてやってから、やっと胸の痞（つかえ）が下りた。吾輩が最後につまみ出されようとしたときに、この家（うち）の主人が騒々しい何だといいながら出て来た。下女は吾輩をぶら下げて主人の方へ向けてこの宿（やど）なしの小猫がいくら出しても出しても御台所（おだいどころ）へ上（あが）って来て困りますという。主人は鼻の下の黒い毛を撚（ひね）りながら吾輩の顔をしばらく眺（なが）めておったが、やがてそんなら内へ置いてやれといったまま奥へ這入（はい）ってしまった。主人はあまり口を聞かぬ人と見えた。下女は口惜（くや）しそうに吾輩を台所へ抛（ほう）り出した。かくして吾輩はついにこの家（うち）を自分の住家（すみか）と極（き）める事にしたのである。"
            {...getOverrideProps(overrides, "content")}
          ></Text>
        </View>
      </Flex>
      <Text
        fontFamily="Inter"
        fontSize="12px"
        fontWeight="400"
        color="rgba(0,0,205,1)"
        lineHeight="14.522727012634277px"
        textAlign="right"
        display="block"
        direction="column"
        justifyContent="unset"
        width="370px"
        height="unset"
        gap="unset"
        alignItems="unset"
        position="absolute"
        top="190px"
        left="15px"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="戻る"
        {...getOverrideProps(overrides, "back")}
      ></Text>
      <View
        width="400px"
        height="175px"
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="0px"
        left="0px"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "ProfileDesignHeader")}
      >
        <Flex
          gap="0"
          direction="column"
          width="400px"
          height="unset"
          justifyContent="flex-start"
          alignItems="center"
          position="absolute"
          top="0px"
          left="0px"
          padding="0px 0px 0px 0px"
          {...getOverrideProps(overrides, "profileBackground")}
        >
          <Flex
            gap="5px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="22px 25px 8px 25px"
            {...getOverrideProps(overrides, "HeaderUpper")}
          >
            <Text
              fontFamily="BIZ UDPGothic"
              fontSize="24px"
              fontWeight="400"
              color="rgba(255,255,255,1)"
              lineHeight="24px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children={person?.name}
              {...getOverrideProps(overrides, "name")}
            ></Text>
            <Text
              fontFamily="BIZ UDPGothic"
              fontSize="12px"
              fontWeight="400"
              color="rgba(255,255,255,1)"
              lineHeight="12px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children={person?.roma}
              {...getOverrideProps(overrides, "roma")}
            ></Text>
            <Icon
              width="230px"
              height="0px"
              viewBox={{ minX: 0, minY: 0, width: 230, height: 1 }}
              paths={[
                {
                  d: "M0 0L230 0L230 -1L0 -1L0 0Z",
                  stroke: "rgba(168,167,221,1)",
                  fillRule: "nonzero",
                  strokeWidth: 1,
                },
              ]}
              display="block"
              gap="unset"
              alignItems="unset"
              justifyContent="unset"
              shrink="0"
              position="relative"
              {...getOverrideProps(overrides, "line")}
            ></Icon>
            <Text
              fontFamily="BIZ UDPGothic"
              fontSize="12px"
              fontWeight="400"
              color="rgba(255,255,255,1)"
              lineHeight="12px"
              textAlign="left"
              display="block"
              direction="column"
              justifyContent="unset"
              width="unset"
              height="unset"
              gap="unset"
              alignItems="unset"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children={person?.email}
              {...getOverrideProps(overrides, "email")}
            ></Text>
          </Flex>
          <Flex
            gap="6px"
            direction="column"
            width="unset"
            height="unset"
            justifyContent="flex-start"
            alignItems="flex-start"
            shrink="0"
            alignSelf="stretch"
            position="relative"
            padding="10px 25px 10px 25px"
            {...getOverrideProps(overrides, "HeaderLower")}
          >
            <Flex
              gap="0"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 9")}
            >
              <Text
                fontFamily="BIZ UDPGothic"
                fontSize="10px"
                fontWeight="700"
                color="rgba(85,85,85,1)"
                lineHeight="10px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="会社名"
                {...getOverrideProps(overrides, "companyLabel")}
              ></Text>
              <Text
                fontFamily="BIZ UDPGothic"
                fontSize="12px"
                fontWeight="400"
                color="rgba(51,51,51,1)"
                lineHeight="12px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children={person?.company}
                {...getOverrideProps(overrides, "company")}
              ></Text>
            </Flex>
            <Flex
              gap="0"
              direction="column"
              width="unset"
              height="unset"
              justifyContent="flex-start"
              alignItems="flex-start"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 10")}
            >
              <Text
                fontFamily="BIZ UDPGothic"
                fontSize="10px"
                fontWeight="700"
                color="rgba(85,85,85,1)"
                lineHeight="10px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children="部署名 / 役職"
                {...getOverrideProps(overrides, "positionLabel")}
              ></Text>
              <Text
                fontFamily="BIZ UDPGothic"
                fontSize="12px"
                fontWeight="400"
                color="rgba(51,51,51,1)"
                lineHeight="12px"
                textAlign="left"
                display="block"
                direction="column"
                justifyContent="unset"
                width="unset"
                height="unset"
                gap="unset"
                alignItems="unset"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                whiteSpace="pre-wrap"
                children={person?.position}
                {...getOverrideProps(overrides, "position")}
              ></Text>
            </Flex>
          </Flex>
        </Flex>
        <Image
          width="122px"
          height="122px"
          display="block"
          gap="unset"
          alignItems="unset"
          justifyContent="unset"
          position="absolute"
          top="24px"
          left="249px"
          border="1px SOLID rgba(255,255,255,1)"
          borderRadius="71px"
          padding="0px 0px 0px 0px"
          objectFit="cover"
          {...getOverrideProps(overrides, "image")}
        ></Image>
      </View>
    </View>
  );
}
